// probe
(() => {
  const isBundleOption = (element) =>
    element instanceof HTMLInputElement && element.matches('input[type="radio"][data-bundle-variant-id]');

  const isBundleProductForm = (form) =>
    form instanceof HTMLFormElement && Boolean(form.closest('product-form[data-nutrivie-bundle-form]'));

  const syncBundleVariantId = (option) => {
    const form = option.form;
    if (!form || !option.checked || !isBundleProductForm(form)) return;

    const variantIdInput = form.querySelector('input[name="id"]');
    const variantId = option.dataset.bundleVariantId;
    if (variantIdInput && variantId) variantIdInput.value = variantId;
  };

  document.addEventListener(
    'change',
    (event) => {
      if (!isBundleOption(event.target)) return;

      const form = event.target.form;
      if (!form || !isBundleProductForm(form)) return;

      syncBundleVariantId(event.target);
    },
    true
  );

  const applyDefaultBundle = (root) => {
    root.querySelectorAll('variant-selects').forEach((selector) => {
      const selectedOption = selector.querySelector('input[type="radio"][data-bundle-variant-id]:checked');
      if (selectedOption) syncBundleVariantId(selectedOption);

      if (selector.dataset.nutrivieDefaultApplied === 'true') return;
      if (new URLSearchParams(window.location.search).has('variant')) return;

      const defaultOption = selector.querySelector('[data-bundle-default]');
      if (!defaultOption || defaultOption.classList.contains('disabled')) return;

      selector.dataset.nutrivieDefaultApplied = 'true';
      if (defaultOption.checked) return;

      defaultOption.checked = true;
      defaultOption.dispatchEvent(new Event('change', { bubbles: true }));
    });
  };

  const initialize = () => applyDefaultBundle(document);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
  } else {
    initialize();
  }

  document.addEventListener('shopify:section:load', (event) => applyDefaultBundle(event.target));
})();
